import { nanoid } from 'nanoid'

export const stData = [
    {
        type: 'para',
        children: [
            {
                text: 'Shanmugham, nicknamed "Benz", is a former stuntman turned taxi driver living in the hill town of Ranni, Kerala with his wife Lalitha and their two children. His dearest possession is a vintage black Ambassador Mark I gifted by his mentor.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Life is peaceful until Shanmugham’s son Pavi takes the Ambassador for a joyride with friends and crashes it. The car goes for repairs at a local mechanic, Kuttichan.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Upon returning home from a trip, Shanmugham finds his beloved car confiscated by the police. Unknown to him, Kuttichan’s assistant had used the vehicle to smuggle weed.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'He pleads with SI Benny to release it but faces dismissiveness. CI George Mathan intervenes and offers to release the car—but only if Shanmugham drives him and Benny to a wedding and stays overnight.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'That night, George drives Shanmugham out to a remote farmhouse in Panchalimedu. There he reveals a horrifying secret: a dead body hidden in Shanmugham’s car trunk. The corpse, buried by George and Benny, is that of Pavi—Shanmugham’s own stepson.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Shattered, Shanmugham returns home, haunted and unsure. His wife Lalitha notices his disturbing silence and when she learns Pavi may have disappeared, Shanmugham rushes to police station—but George and Benny lie that Pavi ran away.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'While cleaning the car, Shanmugham discovers Pavi’s wallet inside. The revelation—that he unknowingly helped bury his own son—drives him into devastation and rage.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Determined to expose the truth, Shanmugham kidnaps Sudheesh, Pavi’s friend, and forces a confession. Sudheesh reveals George had manipulated the situation and falsely accused Pavi.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'When a landslide uncovers the body and forensic confirms it is Pavi, George and Benny fabricate a new narrative: blaming Shanmugham with false media leaks that he killed his own son.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Shanmugham is arrested and held in the station basement, where George plans to eliminate him via corrupt officers. Ultimately, Shanmugham breaks free in a gripping fight and escapes custody, killing Benny in the process.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'He confronts George at his home, learns that Pavi was murdered over a romantic relationship with George’s daughter Mary. George attacked Pavi to protect family honor and then used Shanmugham’s car to cover it up.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'In a brutal climax confrontation, Shanmugham kills George. Mary watches from a window, silently witnessing the truth unfold.',
            },
        ],
        id: nanoid(),
    },
    {
        type: 'para',
        children: [
            {
                text: 'Shanmugham is taken into custody again, escorted to courtroom. A reporter asks if he killed his son. He responds: "I didn’t kill my son. The ones who killed my son… I…" and pauses—leaving consequences implied and the title, Thudarum (continuation), resonant.',
            },
        ],
        id: nanoid(),
    },
]
